import { equalizeTitlesHeight } from '../../components/article-item';

$(document).on('click', '.js-load-more-posts', function(event) {
  event.preventDefault();

  $('.js-articles-row').addClass('is-visible');
  $(this).hide();
  equalizeTitlesHeight();
});
